import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Progress as Progress$1 } from 'reactstrap';

var sizeMapping = {
    xs: 1,
    sm: 3,
    md: 5,
    lg: 8,
    xl: 12
};
var Progress = function (_a) {
    var _b = _a.bar, bar = _b === void 0 ? false : _b, barAriaLabelledBy = _a.barAriaLabelledBy, barAriaValueText = _a.barAriaValueText, barClassName = _a.barClassName, className = _a.className, _c = _a.color, color = _c === void 0 ? 'light' : _c, _d = _a.max, max = _d === void 0 ? 100 : _d, _e = _a.min, min = _e === void 0 ? 0 : _e, _f = _a.multi, multi = _f === void 0 ? false : _f, rounded = _a.rounded, _g = _a.size, size = _g === void 0 ? 'md' : _g, _h = _a.tag, tag = _h === void 0 ? 'div' : _h, _j = _a.value, value = _j === void 0 ? 0 : _j, props = __rest(_a, ["bar", "barAriaLabelledBy", "barAriaValueText", "barClassName", "className", "color", "max", "min", "multi", "rounded", "size", "tag", "value"]);
    var mappedSize = sizeMapping[size];
    return (jsx(Progress$1, __assign({ bar: bar, barAriaLabelledBy: barAriaLabelledBy, barAriaValueText: barAriaValueText, barClassName: classNames(barClassName, rounded && 'rounded-pill'), className: classNames(className, rounded && 'rounded-pill', color !== 'light' && "progress-".concat(color)), "data-testid": "progress-bar", max: max, min: min, multi: multi, style: size && size !== 'md' ? { height: "".concat(mappedSize, "px") } : undefined, tag: tag, value: Math.max(Number(value), Number(min)) }, props)));
};

export { Progress, sizeMapping };
